<ng-template #recipientPanel>

    <div [ngClass]="{'agpr-recipientPanel-extraPadding': showExtraPadding }">
        <div
            *ngFor="let recipientGroup of distribution.recipientInformation.recipientGroups"
            class="agpr-recipientPanel-category"
        >
            <div class="agpr-recipientPanel-categoryRow">
                <span>
                    {{ recipientGroup.label | localize }}
                </span>
                <span class="agpr-recipientPanel-categoryCount">
                    {{ recipientGroup.total }}
                </span>
            </div>
            <div
                *ngFor="let recipient of recipientGroup.recipients"
                class="agpr-recipientPanel-item"
            >
                <span
                    *ngIf="recipient.status === recipientStatus.deleted"
                    class="agpr-recipient-panel-itemlabel"
                >
                    {{ 'Discover.distribution.deleted' | localize }}
                </span>
                <ng-container *ngIf="recipient.label">
                    <span class="agpr-recipientPanel-itemlabel">
                        {{ recipient.label }}
                    </span>
                    <span class="agpr-recipientPanel-count">
                        {{ recipient.count }}
                    </span>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="agpr-recipientPanel-total">
        <span class="agpr-recipientPanel-total-category">
            {{ 'Discover.distribution.totalRecipients' | localize }}
        </span>
        <span class="agpr-recipientPanel-categoryCount">
            {{ distribution.recipientInformation.total }}
        </span>
    </div>

    <agpr-form-message [id]="id + '_error'" *ngIf="error">
        {{ error | localize }}
    </agpr-form-message>
</ng-template>


<ng-container
    *ngIf="showHeader"
>
    <agpr-panel
        header="Discover.distribution.recipients"
        [toggleable]="isToggleable"
    >
        <ng-container *ngTemplateOutlet="recipientPanel"></ng-container>
    </agpr-panel>
</ng-container>

<ng-container
    *ngIf="!showHeader"
>
    <ng-container *ngTemplateOutlet="recipientPanel"></ng-container>
</ng-container>



